import { addAutomation, deleteAutomation, editAutomation, fetchAutomationList, fetchExportData, getAutomationListCnt, getDartDetails, validateAutomationName } from './automation_common_func';
import { Dispatch, SetStateAction } from 'react';

type SelfhelpProps = {
  data: any;
  func: any;
  searchVal: string;
  pageNo: any;
  tenant: string;
  setTotalPages: Dispatch<SetStateAction<number>>;
  setTotalRecords: Dispatch<SetStateAction<number>>;
  exportBtnClicked: boolean;
  setExportBtnClicked: any;
  setExportDetails: any;
  setDartSpecs: any;
  setJsonData: any;
  setUiData: any;
  deleteAutomation: any;
  setDeleteAutomation: any;
  setDeleteDisabled: any;
  isRefresh: any;
  setIsRefresh: any;
  setRefreshToast?: any;
  pageName?: any;
  isFilter?: any;
  dropDownValue1?: any;
  setIsFilter?: any;
  dropdownValue2?: any;
  filterArray: any;
  dartNo: number;
  setFormData: any;
  setSelectedCategoryOptions: any;
  setSelectedSubCategoryOptions: any;
  setSelectedOptions: any;
  setCategorySearchData: any;
  setCategoryData: any;
  setDisableCatInput: any;
  setSubCategorySearchData: any;
  setSubCategoryData: any;
  setDisableSubCatInput: any;
  setAutomationSearchData: any;
  overlayName: string;
  setAutomationSearchDataObj: any;
  formData: any;
  setConfigFormData: any;
  setIsToast: any;
  setToastMessage: any;
  selectedRowIdInTable: any[];
  setErrorToast: any;
  setOverlayOpen: any;
  setSaveBtnClicked: any;
  setOverlayName: any;
  automationSearchDataObj: any;
  categorySearchVal: string;
  subCategorySearchVal: string;
  saveBtnClicked: boolean;
  newData: any;
  rowID: any;
  automationSearchVal: string;
  selectedCategoryOptions: string;
  setSaveTriggered: any;
  dartSpecs: string[];
  setLoading?: any;
  automationName?: any;
  setClassificationNameValidation?: any;
  setAutomationName?: any;
  setAutomationNameInEditForm?: any;
  loading?: boolean;
  searchType: string;
  initialDefaultValue?: any;
  setSpinnerLoad?: any;
}

const selfhelpConfiguration = (props: SelfhelpProps) => {
  const dartNo = props.dartNo;

  const getAutomationList = async (whereCondition: any, limit: number | null = null, offset: number | null = null, type: string = '') => {
    try {
      const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

      if (status === 'success' && data?.length > 0) {
        if (props.overlayName === 'editAutomation') {
          if (type === 'subAutomation') {
            var subAutomationNames: string[] = [];
            var subAutoamtionDataObj: any = {};

            data.map((val: any) => {
              subAutomationNames.push(val.automationName);
              subAutoamtionDataObj[`${val.automationName}`] = val.id;
            })

            props.setAutomationSearchDataObj(subAutoamtionDataObj);
            props.setSelectedOptions(subAutomationNames);
          } else {
            props.setFormData({
              ...props.formData,
              name: data[0]?.automationName,
              description: data[0]?.description,
              jsonData: data[0]?.jsonValue
            });

            var jsonVal = JSON.parse(data[0]?.jsonValue);
            props.setConfigFormData({
              clientEnabled: jsonVal.clientEnabled,
              automation_name: jsonVal.automation_name,
              description: jsonVal.description,
              category: jsonVal.category,
              category_description: jsonVal.category_description,
              sub_category: jsonVal.sub_category,
              sub_category_description: jsonVal.sub_category_description,
              os: jsonVal.os,
              automation_sequence: jsonVal.automation_sequence,
              categoryIcon: jsonVal.categoryIcon, 
              subCategoryIcon: jsonVal.subCategoryIcon,
              categoryIssueLink: jsonVal.categoryIssueLink,
              subCategoryIssueLink: jsonVal.subCategoryIssueLink
            });

            props.setSelectedCategoryOptions([jsonVal?.category]);
            props.setSelectedSubCategoryOptions([jsonVal?.sub_category]);
            props.setSpinnerLoad(false);
            // props.setClassificationNameValidation(true);
            props.setAutomationName(data[0]?.automationName);
            props.setAutomationNameInEditForm(data[0]?.automationName);

            await getAutomationList({ 'types': "automation", id: { _in: jsonVal.automation_sequence.split(",").map(Number) } }, null, null, 'subAutomation');
          }
        } else {
          props.func(data);
          props.setLoading(true);
        }
      } else {
        props.func([]);
      }
    } catch (error) {
      console.log("getAutomationList error=", error);
      props.func([]);
    }
  };

  const getExportData = async (condition: object) => {
    const { data, status } = await fetchExportData(condition);

    if (status === 'success') {
      props.setExportDetails && props.setExportDetails(data);
    }
    props.setExportBtnClicked(false);
  }

  const deleteUnattachedAutomation = async (ids: number[]) => {
    try {
      const { data, status } = await deleteAutomation(ids, 'selfhelp', props.tenant);

      if (status === 'success' && data.affected_rows > 0) {
        props.setDeleteDisabled(true);
        props.setDeleteAutomation(false);
        props.setIsToast(true);

        getAutomationList({ types: ['selfhelp', 'proactive'] }, 50, props.pageNo);
      } else {
        props.setToastMessage(`Self help ${props.selectedRowIdInTable.length < 2 ? 'automation' : 'automations'} deletion failed`);
        props.setErrorToast(true);
      }
    } catch (error) {
      props.setToastMessage(`Self help ${props.selectedRowIdInTable.length < 2 ? 'automation' : 'automations'} deletion failed`);
      props.setErrorToast(true);
    }
  }

  const createAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, tenant: string) => {
    try {
      const { status } = await addAutomation(automationName, description, jsonVal, dartid, 'selfhelp', tenant);

      if (status === 'success') {
        props.setOverlayOpen(false);
        props.setIsToast(true);
        // setTimeout(() => {
        //   props.setSaveBtnClicked(false);
        //   props.setSaveTriggered(false);
        //   props.setOverlayName(false);
        //   props.setAutomationName('');
        // }, 2000);

        getAutomationList({ types: ['selfhelp', 'proactive'] }, 50, props.pageNo);
      } else {
        props.setToastMessage(`${automationName} automation creation failed`);
        props.setErrorToast(true);
      }
    } catch (error) {
      console.log("createAutomation error=", error);
      props.setToastMessage(`${automationName} automation creation failed`);
      props.setErrorToast(true);
    }

    setTimeout(() => {
      props.setSaveBtnClicked(false);
      props.setSaveTriggered(false);
      props.setOverlayName(false);
    }, 2000);
    props.setAutomationName('');
  }

  const modifyAutomation = async (automationName: string, description: string, jsonVal: string, dartid: number, id: number, tenant: string) => {
    try {
      const { status, msg } = await editAutomation(automationName, description, jsonVal, dartid, id, tenant, 'selfhelp');

      if (status === 'success') {
        props.setIsToast(true);
        setTimeout(() => {
          props.setSaveBtnClicked(false);
          props.setSaveTriggered(false);
        }, 100);

        getAutomationList({ types: ['selfhelp', 'proactive'] }, 50, props.pageNo);
      } else if (status === 'failed' && msg?.length > 0) {
        props.setToastMessage("This automation can't be edited as it is already configured");
        props.setErrorToast(true);
      } else {
        props.setToastMessage(`Error occured while saving ${automationName} self-help automation`);
        props.setErrorToast(true);
      }
    } catch (error) {
      console.log("modifyAutomation error=", error);

      props.setToastMessage(`Error occured while saving ${automationName} self-help automation`);
      props.setErrorToast(true);
    }

    setTimeout(() => {
      props.setOverlayOpen(false);
      props.setSaveBtnClicked(false);
      props.setSaveTriggered(false);
      props.setAutomationNameInEditForm('');
      props.setLoading(true);
    }, 100);
    props.setAutomationName('');
  }

  const automationSearch = async (whereCondition: any, limit: number | null, offset: number | null, type: string = 'automation') => {
    try {
      const searchDataArr: string[] = [];
      let searchDataObj: any = {};
      const tempCatObj: any = {};
      const tempSubCatObj: any = {};

      const { data, status } = await fetchAutomationList(whereCondition, limit, offset);

      if (status === 'success' && data.length > 0) {
        searchDataObj = props.automationSearchDataObj;

        data.forEach(async (val: any) => {
          var res: string = type === 'automation' ? val.automationName : type === 'category' ? val.category : type === 'subCategory' ? val.subCategory : val.automationName;

          if (type === 'automation') {
            searchDataObj[`${val.automationName}`] = val.id;
          }

          if (type === 'category') {
            var jsonVal = JSON.parse(val.jsonValue);
            tempCatObj[`${val.category}`] = { desc: jsonVal?.category_description, types: val?.types };
          }

          if (type === 'subCategory') {
            var jsonVal = JSON.parse(val.jsonValue);
            tempSubCatObj[`${val.subCategory}`] = { desc: jsonVal?.sub_category_description, types: val?.types };
          }

          !searchDataArr.includes(res) && searchDataArr.push(res);
        });

        type === 'automation' && props.setAutomationSearchData(searchDataArr);
        type === 'automation' && props.setAutomationSearchDataObj(searchDataObj);

        type === 'category' && props.setCategorySearchData(searchDataArr);
        type === 'category' && props.setCategoryData(tempCatObj);
        type === 'category' && props.setDisableCatInput(true);

        type === 'subCategory' && props.setSubCategorySearchData(searchDataArr);
        type === 'subCategory' && props.setSubCategoryData(tempSubCatObj);
        type === 'subCategory' && props.setDisableSubCatInput(true);
      } else {
        type === 'automation' && props.setAutomationSearchData(searchDataArr);
        type === 'automation' && props.setAutomationSearchDataObj(searchDataObj);

        type === 'category' && props.setCategorySearchData([props.categorySearchVal]);
        type === 'category' && props.setCategoryData(tempCatObj);
        type === 'category' && props.setDisableCatInput(false);

        type === 'subCategory' && props.setSubCategorySearchData([props.subCategorySearchVal]);
        type === 'subCategory' && props.setSubCategoryData(tempSubCatObj);
        type === 'subCategory' && props.setDisableSubCatInput(false);
      }
    } catch (error) {
      console.log("automationSearch error=", error);

    }
  }

  if (props.dartSpecs.length === 0) {
    getDartDetails(dartNo, props.setDartSpecs);
  } else if (props.isRefresh) {
    props.setIsRefresh(false);
    props.setRefreshToast(true);
    setTimeout(() => {
      props.setRefreshToast(false);
    }, 3000);
  }

  if (props.searchVal?.length > 0 && props.searchVal !== '' && props.overlayName === '') {
    getAutomationList({ types: ['selfhelp', 'proactive'], function: 'search', search: props.searchVal }, 50, props.pageNo);

    getAutomationListCnt({ types: ['selfhelp', 'proactive'], function: 'search', search: props.searchVal }, props.setTotalRecords, props.setTotalPages);
  } else if (props.isFilter === true) {
    console.log("enter filter");

    const whereCondition = { "types": ["selfhelp", "proactive"], function: 'filter', filter: props.filterArray };

    getAutomationList(whereCondition, 50, props.pageNo);
    getAutomationListCnt(whereCondition, props.setTotalRecords, props.setTotalPages);
  } else if (props.deleteAutomation && props.selectedRowIdInTable.length > 0) {
    deleteUnattachedAutomation(props.selectedRowIdInTable);
  } else if (props.saveBtnClicked && props.newData !== undefined && Object.keys(props.newData).length > 0 && props.automationName.length > 0) {
    props.overlayName === 'addAutomation' && createAutomation(props.newData.name, props.newData.description, props.newData.jsonData, dartNo, props.tenant);

    props.overlayName === 'editAutomation' && modifyAutomation(props.newData.name, props.newData.description, props.newData.jsonData, dartNo, props.rowID, props.tenant);
  } else if (!(props.saveBtnClicked) && props.overlayName === 'editAutomation' && props.automationSearchVal?.length < 1 && props?.automationName?.length === 0 && !props?.loading) {
    getAutomationList({ types: ['selfhelp', 'proactive'], id: props.rowID }, 0, null);
  } else if (props.automationSearchVal?.length > 0 && props.automationSearchVal !== '' && props.searchType === "automation") {
    automationSearch({ types: 'automation', automationName: { contains: props.automationSearchVal } }, null, null, 'automation');
  } else if (props.categorySearchVal?.length > 0 && props.categorySearchVal !== '' && props.selectedCategoryOptions.length === 0 && props.searchType === "category") {
    automationSearch({ types: ['selfhelp', 'proactive'], category: { contains: props.categorySearchVal } }, null, null, 'category');
  } else if (props.subCategorySearchVal?.length > 0 && props.subCategorySearchVal !== '' && props.searchType === "subCategory") {
    automationSearch({ types: ['selfhelp', 'proactive'], subCategory: { contains: props.subCategorySearchVal } }, null, null, 'subCategory');
  } else if (props.exportBtnClicked) {
    getExportData({ types: ['selfhelp', 'proactive'], function: 'export', tenant: props.tenant });
  } else if (props?.automationName?.length > 0 && props?.overlayName?.length > 0) {
    props?.automationName !== props.initialDefaultValue?.name && validateAutomationName({ "tenant": props.tenant, function: 'validate', automation: props.automationName, types: ['selfhelp', 'proactive'] }, props.setClassificationNameValidation);
  } else if (props?.loading) {
    props.overlayName !== 'addAutomation' && getAutomationList({ types: ['selfhelp', 'proactive'] }, 50, props.pageNo);

    props.overlayName !== 'editAutomation' && getAutomationListCnt({ types: ['selfhelp', 'proactive'] }, props.setTotalRecords, props.setTotalPages);
  }
}

export { selfhelpConfiguration }